import React, { useState } from "react";
import whyChooseUs from "../../Assets/Styles/Home/whyChooseUs.module.css";
import userIcon from "../../Assets/Images/Icons/usericon.png";
import like from "../../Assets/Images/Icons/likeicon.png";
import icon3 from "../../Assets/Images/Icons/Icon (3).png";
import icon4 from "../../Assets/Images/Icons/Icon (2).png";
import shape from "../../Assets/Images/Icons/Shape.png";
import Fade from "react-reveal/Fade";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";

const SuccessBox = () => {
  const [counterOn, setCounter] = useState(false);
  return (
    <Fade bottom>
      {" "}
      <section
        className={`2xl:max-w-[1320px] mb-[93px] mx-5 flex-col max-lg:flex-row  max-xl:max-w-[1150px] flex justify-center items-center gap-20  max-xl:mx-auto ${whyChooseUs.successBox}`}
      >
        <div>
          <img src={userIcon} alt="IT Ghar" />

          <ScrollTrigger
            onEnter={() => setCounter(true)}
            onExit={() => setCounter(false)}
          >
            <h3 className="text-5xl text-[#FFFFFF] font-extrabold mt-8">
              {" "}
              {counterOn && (
                <CountUp duration={5} start={0} end={856} delay={0} />
              )}
            </h3>
          </ScrollTrigger>

          <p className="mt-[7px] text-[#FFFFFF] font-semibold">
            Happy Customer
          </p>
        </div>
        <img src={shape} alt="IT Ghar" />
        <div>
          <img src={like} alt="IT Ghar" />

          <ScrollTrigger
            onEnter={() => setCounter(true)}
            onExit={() => setCounter(false)}
          >
            <h3 className="text-5xl text-[#FFFFFF] font-extrabold mt-8">
              {" "}
              {counterOn && (
                <CountUp duration={5} start={0} end={103} delay={0} />
              )}
            </h3>
          </ScrollTrigger>

          <p className="mt-[7px] text-[#FFFFFF] font-semibold">Team Member</p>
        </div>
        <img src={shape} alt="IT Ghar" />
        <div>
          <img src={icon3} alt="IT Ghar" />

          <ScrollTrigger
            onEnter={() => setCounter(true)}
            onExit={() => setCounter(false)}
          >
            <h3 className="text-5xl text-[#FFFFFF] font-extrabold mt-8">
              {" "}
              {counterOn && (
                <CountUp duration={5} start={0} end={11} delay={0} />
              )}
            </h3>
          </ScrollTrigger>

          <p className="mt-[7px] text-[#FFFFFF] font-semibold">Award Winning</p>
        </div>
        <img src={shape} alt="IT Ghar" />
        <div>
          <img src={icon4} alt="IT Ghar" />

          <ScrollTrigger
            onEnter={() => setCounter(true)}
            onExit={() => setCounter(false)}
          >
            <h3 className="text-5xl text-[#FFFFFF] font-extrabold mt-8">
              {" "}
              {counterOn && (
                <CountUp duration={5} start={0} end={263} delay={0} />
              )}
            </h3>
          </ScrollTrigger>

          <p className="mt-[7px] text-[#FFFFFF] font-semibold">
            Project Complete
          </p>
        </div>
      </section>
    </Fade>
  );
};

export default SuccessBox;
